import { render } from "./ListIcon.vue?vue&type=template&id=fb7b719c&scoped=true"
const script = {}

import "./ListIcon.vue?vue&type=style&index=0&id=fb7b719c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fb7b719c"

export default script